import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { EndpointKey } from '../http/EndpointKey';
import imageUrls from '../images/imageUrls';
import { retryEndpoint } from '../store/http-responses/action-creators';
import { ErrorKey } from './ErrorKey';
import StandardError from './StandardError';
import { getIntegrationKey } from '../routing/getIntegrationKey';
import { Integration } from 'signup-constants/Integration';
import { jsx as _jsx } from "react/jsx-runtime";
const IntegratedAppAuthorizationErrorView = ({
  errorKey,
  endpointKey
}) => {
  const dispatch = useDispatch();
  const handleButtonClick = useCallback(() => dispatch(retryEndpoint(endpointKey)), [dispatch, endpointKey]);
  return /*#__PURE__*/_jsx(StandardError, {
    errorKey: errorKey,
    handleButtonClick: handleButtonClick,
    imageURL: imageUrls.computerError
  });
};
const withIntegration = WrappedComponent => {
  return () => {
    const integrationName = getIntegrationKey();
    let errorKey;
    let endpointKey;
    switch (integrationName) {
      case Integration.ShopifyEmbedded:
        errorKey = ErrorKey.IntegratedAppAuthorizationError;
        endpointKey = EndpointKey.ShopifyEmbeddedAuthorization;
        break;
      case Integration.Wordpress:
      default:
        errorKey = ErrorKey.WordpressAuthorizationError;
        endpointKey = EndpointKey.WordpressAuthorization;
        break;
    }
    return /*#__PURE__*/_jsx(WrappedComponent, {
      endpointKey: endpointKey,
      errorKey: errorKey
    });
  };
};
export default withIntegration(IntegratedAppAuthorizationErrorView);